<template>
  <div class="ma-1 mt-5">
    <v-card
      v-if="
        checkaccessdata.is_viewer == false && checkaccessdata.is_maker == false
      "
      class="mt-16"
      flat
    >
      <v-row justify="center" align="center">
        <v-card-title class="red--text"><h2>Access Denied</h2></v-card-title>
      </v-row>
      <v-row justify="center" align="center">
        <v-card-subtitle class="subtitle-1"
          >You do not have Permission to access.</v-card-subtitle
        >
      </v-row>
    </v-card>
    <v-card v-else>
      <v-data-table
        dense
        :headers="headers"
        :items="userTypelist"
        :search="search"
        :options.sync="pagination"
        :items-per-page="itemsPerPage"
        @update:options="userTypeListPagination()"
        :no-data-text="Nodata"
      >
        <template v-slot:[`item.sl_no`]="{ item }">
          <span class="caption">{{ userTypelist.indexOf(item) + 1 }}</span>
        </template>
        <template v-slot:[`item.ut_name`]="{ item }">
          <span class="caption">{{ item.ut_name }}</span>
        </template>
        <template v-slot:[`item.role_name`]="{ item }">
          <span class="caption">{{ item.role_name }}</span>
        </template>
        <template v-slot:[`item.grade_name`]="{ item }">
          <span class="caption">{{ item.grade_name }}</span>
        </template>
        <template v-slot:[`item.loc_name`]="{ item }">
          <span class="caption">{{ item.loc_name }}</span>
        </template>
        <template v-slot:[`item.created_on`]="{ item }">
          <span class="caption">{{ item.created_on }}</span>
        </template>
        <template v-slot:top>
          <v-layout class="mb-4" row wrap>
            <v-row>
              <v-col cols="3">
                <v-card-title class="ml-4 primary--text">
                  <v-btn @click="back" class="ml-n7 primary--text" text>
                    <v-icon>mdi-reply</v-icon></v-btn
                  >
                  User Type
                  <!-- <v-divider vertical class="ml-5 mx-0"></v-divider> -->
                </v-card-title>
              </v-col>
              <v-spacer />
              <v-col cols="3" class="mt-4 ml-2">
                <v-text-field
                  v-model="search"
                  shaped
                  outlined
                  dense
                  class="mt-n1"
                  color="primary"
                  append-icon="mdi-magnify"
                  label="Search"
                  hide-details
                ></v-text-field>
              </v-col>
              <v-col cols="1" class="mt-3 mr-4">
                <v-dialog persistent v-model="addCategory" width="500">
                  <v-toolbar dark dense class="header">
                    <v-icon>mdi-plus</v-icon>
                    <span class="ml-3">Add User Type</span>
                    <v-spacer></v-spacer>
                    <v-btn class text dark @click="clearData">
                      <v-icon color="white" small>mdi-close</v-icon>
                    </v-btn>
                  </v-toolbar>
                  <template #activator="{ on: addCategory }">
                    <v-tooltip bottom color="primary">
                      <template #activator="{ on: tooltip }">
                        <v-btn
                          rounded
                          class="navbar white--text ml-0"
                          v-on="{ ...addCategory, ...tooltip }"
                        >
                          <v-icon>mdi-plus</v-icon>
                        </v-btn>
                      </template>
                      <span class="white--text">Set User Type</span>
                    </v-tooltip>
                  </template>
                  <v-card>
                    <v-divider></v-divider>
                    <v-form ref="formUserType">
                      <v-row class="mt-8 mx-7">
                        <v-text-field
                          v-model="userName"
                          :rules="nameRules"
                          label="User Type*"
                          color="primary"
                          required
                          outlined
                          dense
                          @keydown.space="preventLeadingSpace"
                          maxlength="120"
                        ></v-text-field>
                      </v-row>
                      <v-row class="mx-7">
                        <v-select
                          v-model="roleName"
                          :rules="nameRules"
                          label="Role Name *"
                          color="primary"
                          :items="roleDatalist"
                          item-text="role_name"
                          item-value="role_id"
                          required
                          outlined
                          dense
                          maxlength="120"
                        ></v-select>
                      </v-row>
                      <v-row class="mx-7">
                        <v-select
                          v-model="gradesName"
                          :rules="nameRules"
                          label="Grade"
                          :items="gradesDatalist"
                          item-text="grade_name"
                          item-value="grade_id"
                          required
                          outlined
                          dense
                        ></v-select>
                      </v-row>
                      <v-row class="mx-7">
                        <v-select
                          v-model="locatioName"
                          color="primary"
                          :rules="nameRules"
                          :items="locationDatalist"
                          item-text="loc_name"
                          label="Location"
                          item-value="loc_id"
                          required
                          outlined
                          dense
                        ></v-select>
                      </v-row>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                          rounded
                          class="primary elevation-6 white--text mr-3 mb-2"
                          :loading="isLoading"
                          medium
                          @click="createUserType"
                        >
                          Add
                        </v-btn>
                      </v-card-actions>
                    </v-form>
                  </v-card>
                </v-dialog>
              </v-col>
            </v-row>
          </v-layout>
        </template>
      </v-data-table>
    </v-card>
    <OverleyProccessg :overlay="overlay" />
  </div>
</template>

<script>
import OverleyProccessg from "@/Views/OverleyProccessg.vue";
import { apiCall } from "@/Views/APICALL/APIcall.js";

export default {
  components: {
    OverleyProccessg,
  },
  data: () => ({
    userName: "",
    nameRules: [(v) => !!v || "Required"],
    locatioName: "",
    roleName: "",
    gradesName: "",
    locationDatalist: [],
    userTypelist: [],
    Nodata: "",
    locationList: ["Bangalore", "Pune", "Mumbai"],
    gradeList: ["G1", "G2", "G3"],
    roleList: ["Sales Manager", "Sales Admin", "IT Manager", "HR"],
    rulesValue: "",
    addCategory: false,
    search: "",
    isLoading: false,
    Address: "",
    Name: "",
    Description: "",
    markers: [],
    startCategory: {
      lat: 80,
      lng: 90,
    },
    getdepartmentlist: [],
    headers: [
      { text: "SL NO", value: "sl_no" },
      {
        text: "USER TYPE ",
        value: "ut_name",
      },
      {
        text: "ROLE NAME",
        value: "role_name",
      },
      {
        text: "GRADE",
        value: "grade_name",
      },
      {
        text: "LOCATION",
        value: "loc_name",
      },
      {
        text: "CREATED ON",
        value: "created_on",
      },
    ],
    categorylist: [
      {
        name: "Mobil80",
        Address: "vidyaranyapura, india",
        created_on: "25-02-2021",
      },
    ],
    roleDatalist: [],
    gradesDatalist: [],
    overlay: false,
    checkaccessdata: {},
    itemsPerPage: 25,
    pagination: {
      rowsPerPage: 20,
      page: 1,
    },
    pageCount: 0,
  }),
  mounted() {
    // this.getdepartment();
    this.checkaccess();
  },
  methods: {
    async checkaccess() {
      var inputData = {
        method_name: "ACCESS",
        page_no: 0,
        record_count: 0,
        page_size: 25,
        app_code: "CPORTAL",
        method_param: {
          action: "CHECK_ACCESS",
          user_id: this.$store.getters.get_userid,
          module_code: "SETTINGS",
          module_type: "2",
        },
      };
      var responseData = await apiCall(inputData);

      this.checkaccessdata = responseData.data.data;
      // console.log("checkaccessdata", this.checkaccessdata);
      if (this.checkaccessdata.is_viewer == true) {
        this.getRoleTableList();
        this.getGradesList();
        this.getLocatnList();
        this.userTypeList();
      }
    },
    back() {
      this.$router.push("/Dashboard");
    },
    async createUserType() {
      if (this.$refs.formUserType.validate()) {
        this.isLoading = true;
        var inputData = {
          method_name: "EXPENSE",
          page_no: 0,
          record_count: 0,
          page_size: 25,
          app_code: "CPORTAL",
          method_param: {
            action: "CUSRTP",
            corp_id: this.$store.getters.get_corpid,
            ut_name: this.userName,
            role_id: this.roleName,
            grade_id: this.gradesName,
            loc_id: this.locatioName,
          },
        };
        //    console.log("inputData", inputData);
        var responseData = await apiCall(inputData);
        if (responseData.data.status == "00") {
          this.$store.commit("snackbar/showMessage", {
            content: responseData.data.status_msg,
            color: "green",
          });
          this.clearData();
        } else {
          this.$store.commit("snackbar/showMessage", {
            content: responseData.data.status_msg,
            color: "red",
          });
          this.clearData();
        }
        this.userTypeList();
        // console.log(responseData.data.data);
      }
    },
    clearData() {
      this.isLoading = false;
      this.addCategory = false;
      this.$refs.formUserType.reset();
      this.$refs.formUserType.resetValidation();
    },
    async card_getuserPagination() {
      if (this.empitems.length < this.totalCount) {
        this.pageCount = this.pageCount + 1;

        //methodname and action Changes  (CommonAPimethod)
        var inputData = {
          method_name: "BUDGET",
          page_no: this.pageCount,
          record_count: 0,
          page_size: 50,
          app_code: "CPORTAL",
          method_param: {
            action: "GUSRBUDGET",
            search_text: "",
            corp_id: this.$store.getters.get_corpid,
            department_id: this.department_id,
          },
        };

        var responseData = await apiCall(inputData);

        this.empitems = this.empitems.concat(responseData.data.data);
      }
    },
    async userTypeListPagination() {
      if (this.userTypelist.length < this.totalCount) {
        this.pageCount = this.pageCount + 1;

        //methodname and action Changes  (CommonAPimethod)
        var inputData = {
          method_name: "EXPENSE",
          page_no: this.pageCount,
          record_count: 0,
          page_size: 50,
          app_code: "CPORTAL",
          method_param: {
            action: "GCUSRTP",
            corp_id: this.$store.getters.get_corpid,
            search_text: "",
          },
        };

        var responseData = await apiCall(inputData);

        this.userTypelist = this.userTypelist.concat(responseData.data.data);
      }
    },
    async userTypeList() {
      this.overlay = true;
      var inputData = {
        method_name: "EXPENSE",
        page_no: 0,
        record_count: 0,
        page_size: 25,
        app_code: "CPORTAL",
        method_param: {
          action: "GCUSRTP",
          corp_id: this.$store.getters.get_corpid,
          search_text: "",
        },
      };
      var responseData = await apiCall(inputData);
      //   console.log(responseData.data.data);

      if (responseData.data.status == "00") {
        if (responseData.data.data != null || responseData.data.data != "") {
          this.userTypelist = responseData.data.data;
          this.totalCount = responseData.data.data[0].total_count;
        }
        this.overlay = false;
      } else if (responseData.data.status == "NOREC") {
        this.Nodata = responseData.data.status_msg;
        this.overlay = false;
        this.userTypelist = [];
      }
    },
    async getRoleTableList() {
      //alert(90);

      var inputData = {
        method_name: "SETTINGS",
        page_no: 0,
        record_count: 0,
        page_size: 25,
        app_code: "CPORTAL",
        method_param: {
          action: "GROLES",
          corp_id: this.$store.getters.get_corpid,
          search_text: "",
        },
      };
      var responseData = await apiCall(inputData);
      // console.log("roleDatalist", responseData.data.data);
      if (responseData.data.status == "00") {
        if (responseData.data.data != null || responseData.data.data != "") {
          this.roleDatalist = responseData.data.data;
        }
      } else {
        this.roleDatalist = [];
      }

      // this.$emit("backChild");
      // this.$store.commit("snackbar/showMessage", {
      //   content: "Acknowledged Proxy Numbers",
      //   color: "green"
      // });
      // this.ackdialog = false;
    },
    async getGradesList() {
      var inputData = {
        method_name: "SETTINGS",
        page_no: 0,
        record_count: 0,
        page_size: 25,
        app_code: "CPORTAL",
        method_param: {
          action: "GGRADE",
          corp_id: this.$store.getters.get_corpid,
          search_text: "",
        },
      };
      var responseData = await apiCall(inputData);

      if (responseData.data.status == "00") {
        if (responseData.data.data != null || responseData.data.data != "") {
          this.gradesDatalist = responseData.data.data;
        }
        //    console.log("gradesDatalist", this.gradesDatalist);
      } else {
        this.gradesDatalist = [];
      }
    },
    async getLocatnList() {
      var inputData = {
        method_name: "SETTINGS",
        page_no: 0,
        record_count: 0,
        page_size: 25,
        app_code: "CPORTAL",
        method_param: {
          action: "GLOC",
          corp_id: this.$store.getters.get_corpid,
          search_text: "",
        },
      };
      var responseData = await apiCall(inputData);

      if (responseData.data.status == "00") {
        if (responseData.data.data != null || responseData.data.data != "") {
          this.locationDatalist = responseData.data.data;
        }
        //  console.log("locationDatalist", this.locationDatalist);
      } else {
        this.locationDatalist = [];
      }
    },
    preventLeadingSpace(e) {
      if (!e.target.value) e.preventDefault();
      else if (e.target.value[0] == " ")
        e.target.value = e.target.value.replace(/^\s*/, "");
    },
  },
};
</script>

<style>
.navbar {
  background: linear-gradient(to bottom, #2e4152 0%, #3c4d5d 50%, #202c37 100%);
}
</style>
